var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.23-240v60q0 8.5-5.75 14.25T189.23-160H180q-8.5 0-14.25-5.75T160-180v-293.85L239.38-700q2.93-9.54 11.27-14.77Q259-720 269.23-720h424.62q9.08 0 16.49 5.5 7.41 5.5 10.28 14.5L800-473.85V-180q0 8.5-5.75 14.25T780-160h-9.23q-8.5 0-14.25-5.75T750.77-180v-60H209.23Zm7.39-273.85h526.76L684.46-680H275.54l-58.92 166.15Zm-16.62 40V-280v-193.85Zm97.1 141.54q18.67 0 31.55-13.06 12.89-13.07 12.89-31.73 0-18.67-13.07-31.55-13.06-12.89-31.73-12.89-18.66 0-31.55 13.07-12.88 13.06-12.88 31.73 0 18.66 13.06 31.55 13.07 12.88 31.73 12.88Zm366.16 0q18.66 0 31.55-13.06 12.88-13.07 12.88-31.73 0-18.67-13.06-31.55-13.07-12.89-31.73-12.89-18.67 0-31.55 13.07-12.89 13.06-12.89 31.73 0 18.66 13.07 31.55 13.06 12.88 31.73 12.88ZM200-280h560v-193.85H200V-280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.02dbf862160cedb265bc6703f6fdb2b5.svg";
export { ForwardRef as ReactComponent };